import { ButtonTertiary } from "@nova/component-btn"
import * as Icons from "@nova/component-icons"
import { InputOutlined } from "@nova/ds-component-input"
import { ButtonSplit } from "@nova/ds-component-button-split"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import {
    selectChecklistFilter,
    selectDateFilter,
    selectDroneFilter,
    selectFlightsSearch,
    selectPilotFilter,
    selectTagFilter,
} from "../redux/missions-table-selectors"
import {
    ALL_MISSIONS_TABLE_FILTERS,
    setChecklistFilter,
    setDateFilter,
    setDroneFilter,
    setPilotFilter,
    setSearch,
    setTagFilter,
    type MissionsTableFilter,
} from "../redux/missions-table-slice"
import { DateFilter } from "../filters/DateFilter"
import { DroneFilter } from "../filters/DroneFilter"
import { PilotFilter } from "../filters/PilotFilter"
import { TagFilter } from "../filters/TagFilter"

export const MissionsTableFilterBar = ({
    filters = [...ALL_MISSIONS_TABLE_FILTERS],
}: {
    filters?: MissionsTableFilter[]
}) => {
    const has = (f: MissionsTableFilter) => filters.includes(f)
    const dispatch = useAppDispatch()
    const dateFilter = useAppSelector(selectDateFilter)
    const pilotFilter = useAppSelector(selectPilotFilter)
    const droneFilter = useAppSelector(selectDroneFilter)
    const tagFilter = useAppSelector(selectTagFilter)
    const checklistFilter = useAppSelector(selectChecklistFilter)
    const search = useAppSelector(selectFlightsSearch)

    return (
        <div className="flex flex-col min-[1090px]:flex-row min-[1090px]:items-center gap-4">
            <div className="flex items-center gap-1 flex-1 flex-wrap">
                {has("date") && (
                    <div className="w-fit">
                        <DateFilter
                            value={dateFilter ?? undefined}
                            onChange={(v) => dispatch(setDateFilter(v ?? null))}
                        />
                    </div>
                )}
                {has("pilot") && (
                    <div className="w-fit">
                        <PilotFilter
                            value={pilotFilter ?? undefined}
                            onChange={(v) => dispatch(setPilotFilter(v ?? null))}
                        />
                    </div>
                )}
                {has("drone") && (
                    <div className="w-fit">
                        <DroneFilter
                            value={droneFilter ?? undefined}
                            onChange={(v) => dispatch(setDroneFilter(v ?? null))}
                        />
                    </div>
                )}
                {has("tag") && (
                    <div className="w-fit">
                        <TagFilter value={tagFilter} onChange={(v) => dispatch(setTagFilter(v))} />
                    </div>
                )}
                {has("checklist") && (
                    <>
                        {checklistFilter ? (
                            <ButtonSplit
                                label="Checklist Missing"
                                onRightClick={(e) => {
                                    e.stopPropagation()
                                    dispatch(setChecklistFilter(false))
                                }}
                                leftIcon={Icons.Checkmark}
                            />
                        ) : (
                            <ButtonTertiary
                                title="Checklist Missing"
                                className="shrink-0"
                                onClick={() => dispatch(setChecklistFilter(true))}
                            />
                        )}
                    </>
                )}
            </div>
            {has("search") && (
                <InputOutlined
                    value={search}
                    onChange={(e) => dispatch(setSearch(e.currentTarget.value))}
                    placeholder="Search"
                    leftItem={<Icons.Icon Icon={Icons.MagnifyingGlass} className="mr-1" />}
                    size="sm"
                    className="max-w-[210px]"
                />
            )}
        </div>
    )
}
